import { css } from "@emotion/react";
import {
  InformationPanel,
  TextLink,
} from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import {
  AlertCode,
  AlertLinkType,
  AlertType,
} from "@/generated/graphql_billing";
import { useRouter } from "next/router";

type Props = {
  alerts: {
    alertID: number;
    alertType: AlertType;
    code?: AlertCode;
    linkType: AlertLinkType;
    linkURL: string;
    message: string;
  }[];
  onClose?: (alertId: number) => void;
  linkText?: string;
};
export const Alert = (props: Props) => {
  const router = useRouter();
  const LinkComponent = (linkType: string, linkUrl: string) => {
    if (linkType === AlertLinkType.External) {
      return (
        <TextLink target={"_blank"} href={linkUrl}>
          {props.linkText}
        </TextLink>
      );
    } else if (AlertLinkType.Internal) {
      return (
        <span onClick={() => router.push(linkUrl)} css={linkButton}>
          {props.linkText}
        </span>
      );
    } else {
      return;
    }
  };

  return (
    <>
      {props.alerts.map((alert) => {
        const alertId = alert.alertID;
        const title = alert.message;
        const alertType = alert?.alertType;
        const linkType = alert?.linkType;
        const linkUrl = alert?.linkURL || "";

        return (
          <div key={alertId} css={{ marginBottom: 8 }}>
            <InformationPanel
              variant={alertType === AlertType.Warning ? "attention" : "info"}
            >
              <span>{title}</span>
              <span css={{ marginLeft: 16 }}>
                {LinkComponent(linkType, linkUrl)}
              </span>
            </InformationPanel>
          </div>
        );
      })}
    </>
  );
};

const linkButton = css({
  color: color.link,
  whiteSpace: "nowrap",
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
});
